module.exports = __webpack_public_path__ + "src/assets/img/bg-dialog.ac6a25.png";